(() => {
  if (window.Hydtec3DViewerInitialized) return;
  window.Hydtec3DViewerInitialized = true;

  const mounts = document.querySelectorAll("[data-hydtec-3d-viewer]");
  let activeMount = null;
  let activeModal = null;
  let lastFocusedElement = null;

  mounts.forEach((mount) => {
    if (mount.dataset.hydtecInitialized === "true") return;
    mount.dataset.hydtecInitialized = "true";

    const productId = mount.getAttribute("data-product-id");
    const openButton = mount.querySelector("[data-hydtec-3d-open]");
    const modal = mount.querySelector("[data-hydtec-3d-modal]");
    const closeButton = mount.querySelector("[data-hydtec-3d-close]");
    const panel = mount.querySelector("[data-hydtec-3d-panel]");
    const frameWrapper = mount.querySelector("[data-hydtec-3d-frame]");
    const statusElement = mount.querySelector("[data-hydtec-3d-status]");

    if (!productId || !openButton || !modal || !frameWrapper) return;

    /*
      This is the key fix:
      The button stays inside the gallery,
      but the modal gets moved outside the gallery into <body>.
    */
    document.body.appendChild(modal);

    preloadModel({
      mount,
      productId,
      frameWrapper,
      statusElement,
      openButton,
    });

    openButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      openModal(mount, modal, openButton, closeButton);
    });

    closeButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal(modal);
    });

    modal.addEventListener("click", (event) => {
      if (event.target === modal) {
        closeModal(modal);
      }
    });

    panel?.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    panel?.addEventListener("pointerdown", (event) => {
      event.stopPropagation();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    if (activeModal && !activeModal.hidden) {
      closeModal(activeModal);
    }
  });

  async function preloadModel({ mount, productId, frameWrapper, statusElement, openButton }) {
    mount.classList.add("hydtec-3d-viewer--loading");
    openButton.setAttribute("aria-busy", "true");

    try {
      const response = await fetch("/apps/hydtec-3d-viewer/model", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ productId }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error?.message || "Could not load 3D model.");
      }

      const iframe = document.createElement("iframe");
      iframe.className = "hydtec-3d-viewer__iframe";
      iframe.src = data.url;
      iframe.title = data.fileName || mount.dataset.i18nTitle;
      iframe.loading = "eager";
      iframe.allowFullscreen = true;
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");

      frameWrapper.replaceChildren(iframe);

      mount.classList.remove("hydtec-3d-viewer--loading");
      mount.classList.add("hydtec-3d-viewer--ready");

      openButton.removeAttribute("aria-busy");
    } catch (error) {
      const message = mount.dataset.i18nError;

      mount.classList.remove("hydtec-3d-viewer--loading");
      mount.classList.add("hydtec-3d-viewer--error");

      if (statusElement) {
        statusElement.classList.add("hydtec-3d-viewer__status--error");
        statusElement.textContent = message;
      } else {
        const errorElement = document.createElement("div");
        errorElement.className = "hydtec-3d-viewer__status hydtec-3d-viewer__status--error";
        errorElement.textContent = message;
        frameWrapper.replaceChildren(errorElement);
      }

      openButton.removeAttribute("aria-busy");
      openButton.setAttribute("title", message);
    }
  }

  function openModal(mount, modal, openButton, closeButton) {
    lastFocusedElement = document.activeElement;
    activeMount = mount;
    activeModal = modal;

    modal.hidden = false;
    document.documentElement.classList.add("hydtec-3d-viewer-modal-open");
    document.body.classList.add("hydtec-3d-viewer-modal-open");

    openButton.setAttribute("aria-expanded", "true");

    window.requestAnimationFrame(() => {
      closeButton?.focus();
    });
  }

  function closeModal(modal) {
    modal.hidden = true;

    document.documentElement.classList.remove("hydtec-3d-viewer-modal-open");
    document.body.classList.remove("hydtec-3d-viewer-modal-open");

    if (activeMount) {
      const openButton = activeMount.querySelector("[data-hydtec-3d-open]");
      openButton?.setAttribute("aria-expanded", "false");
    }

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus();
    }

    activeMount = null;
    activeModal = null;
    lastFocusedElement = null;
  }
})();